import React from 'react';
import MailInboxContain from '../../Componant/Email/MailInbox';

const EmailInBox = () => {
  return (
    <div className='page-body'>
      <MailInboxContain />
    </div>
  );
};

export default EmailInBox;
